<template>
  <div :class="{'headerIndex':isHeader,'header':true}" >
    <!--    <div class="top-line warp-outer">
      <div class="container">
        <ul class="list-inline pull-left">
          <li class="hidden-xs">
            <router-link to="/">首页</router-link>
          </li>
          <li class="hidden-sm hidden-xs"></li>
          <li class="hidden-sm hidden-xs pc-numberP">联系电话：0759-2221090</li>

        </ul>
        <div class="nav nav-pills" role="tablist">
          <div class="dropdown pull-right">
            <a id="drop" class="user-link visible-xs dropdown-toggle" href="#" data-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false">
              <span class="glyphicon glyphicon-user"></span>
            </a>
            <ul class="dropdown-menu" role="menu" aria-labelledby="drop">
              <template v-if="!user.user_name">
                <li role="presentation">
                  <router-link to="/login">登录</router-link>
                </li>
                <li role="presentation">
                  <router-link to="/regist">注册</router-link>
                </li>
              </template>
              <template v-else>
                <img src="../assets/img/icon-3-06.png" style="width:20px;height:20px;" />
                <li role="presentation">
                  {{user.user_name}}
                </li>
                <li role="presentation">
                  <router-link to="/center">个人中心</router-link>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
    </div> -->
    <div class="clearfix"></div>
    <div class="top-nav warp-outer">
      <div class="container">
        <div class="navbar navbar-default" role="navigation">
          <div class="container-fluid">
            <div class="navbar-header">
              <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar">
                <span class="sr-only"></span> <span class="icon-bar"></span> <span
                  class="icon-bar"></span> <span class="icon-bar"></span>
              </button>
              <a class="navbar-brand">
                <img style="width:100px;border-radius: 8px;display: inline-block;margin-right:8px;" src="../assets/img/database-logo.jpeg" alt="热带水果品质与营养基础数据库">
                <h2 style="display: inline-block;vertical-align: top;">热带水果品质与营养基础数据库</h2>
                <!-- <img src="../assets/img/logo.png" alt="食品安全查询系统_食品安全技术服务平台-食安通官网"> -->
              </a>
            </div>
            <ul class="nav navbar-nav navbar-right" role="menu" aria-labelledby="drop" style="padding-top: 24px;">
              <template v-if="!user.user_name">
                <li class="login-form login-form2" style="">
                  <form action="##" class="form-horizontal" role="form">
                    <div class="form-group">
                      <label for="phone" class="control-label text-right">邮箱</label>
                      <div class="form-group-right">
                        <input type="text" name="userName" id="userName" class="form-control input-icon input-user"
                          placeholder="请输入邮箱" v-model="email" style="font-size:14px !important;">
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="password" class="control-label text-right">密码</label>
                      <div class="form-group-right">
                        <input type="password" name="password" id="password" class="form-control input-icon input-paw"
                          placeholder="请输入密码" v-model="password" style="font-size:14px !important;">
                      </div>
                    </div>
                  </form>
                </li>
                <li role="presentation">
                  <a @click="handleLogin" style="cursor:pointer">登录</a>
                  <!-- <router-link to="/login">登录</router-link> -->
                </li>
                <li role="presentation">
                  <router-link to="/regist">注册</router-link>
                </li>
                <li role="presentation">
                  <a @click="forgetPassword" style="cursor:pointer">忘记密码</a>
                </li>
              </template>
              <template v-else>
                <li style="position: relative;top: 14px;right: -6px;">
                  <img src="../assets/img/icon-3-06.png" style="width:20px;height:20px;" />
                </li>
                <li role="presentation">
                  <a>
                    {{user.user_name}}
                  </a>
                </li>
                <li role="presentation" style="line-height: 50px;">
                  <el-button type="primary" size="small" @click="handlePph">多酚专题</el-button>
                </li>
                <li role="presentation">
                  <router-link to="/center" style="cursor:pointer;">个人中心</router-link>
                </li>
                <li role="presentation">
                  <router-link to="/" style="cursor:pointer;">首页</router-link>
                </li>
                <li role="presentation">
                  <a @click="logout" style="cursor:pointer;">退出</a>
                </li>
              </template>
            </ul>
            <!-- <ul class="nav navbar-nav navbar-right">
                <li><router-link to="/">首页</router-link></li>
              </ul> -->
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="找回密码" :visible.sync="dialogVisible" width="500px">
      <div class="login-form">
        <form id="inputForm" action="/sat/register/newregister" class="form-horizontal" role="form" onsubmit="return false;" style="width:424px;margin:0 auto;">
          <div class="form-group">
            <label for="email" class="control-label text-right"><i class="required-icon">*</i>您的邮箱</label>
            <div class="form-group-right">
              <input type="email" id="email" name="email" class="form-control input-icon input-user" placeholder="请输入您的邮箱" v-model="user_email">
            </div>
          </div>
          <div class="form-group">
            <label for="checkCode" class="control-label text-right"><i class="required-icon">*</i>验证码</label>
            <div class="form-group-right input-nesting-box">
              <div class="col-md-7 col-sm-7 col-xs-6">
                <input type="text" id="checkCode" name="checkCode" maxlength="6" class="form-control input-icon input-code" required="" v-model="email_code">
              </div>
              <div class="col-md-5 col-sm-5 col-xs-6 text-right">
                <button type="button" id="input_btn" class="btn btn-set-code" @click="getEmailCode">
                  获取<span class="hidden-xs">邮箱</span>验证码
                </button>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="pwd" class="control-label text-right"><i class="required-icon">*</i>设置密码</label>
            <div class="form-group-right">
              <input type="password" id="pwd" name="pwd" class="form-control input-icon input-paw" placeholder="请输入密码" minlength="6" maxlength="16" required="" v-model="user_password">
            </div>
          </div>
          <div class="form-group">
            <label for="confirmPassword" class="control-label text-right"><i class="required-icon">*</i>确认密码</label>
            <div class="form-group-right">
              <input type="password" id="repwd" name="repwd" class="form-control input-icon input-paw" placeholder="请输入密码" minlength="6" maxlength="16" required="" v-model="user_password2">
            </div>
          </div>
        </form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { Post, Get } from '@/api/utils'
export default {
  name: 'header1',
  props: {
    msg: String
  },
  data() {
    return {
      isdisabled:false,
      email: '',
      password: '',
      dialogVisible: false,
      user_email: '',
      email_code: '',
      user_password: '',
      user_password2: '',
      isHeader:true
    }
  },
  created() {
    if(this.$route.name == 'index'){
      this.isHeader = false
    }
    // console.log('this.$store.user', this.$store)
  },
  watch:{
      $route(to,from){
        //console.log(from.path);//从哪来
        // console.log(to.path);//到哪去
        if(to.path == '/'){
          this.isHeader = false
        }else {
          this.isHeader = true
        }
      }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    // routeName(){
    //   if(this.$store.state.routeName == 'index'){
    //     this.isHeader = false
    //   }
    //   return this.$store.state.routeName
    // }
  },
  methods: {
    handleSure() {
      if (!this.user_email && !this.email_code && !this.user_password && !this.user_password2) {
        this.$message.error('请将信息填写完整~');
        return;
      }
      if (!/^([a-zA-Z\d])((\w|-)+\.?)+@([a-zA-Z\d]+\.)+[a-zA-Z]{2,6}$/.test(this.user_email)) {
        this.$message.error('邮箱格式有误，请检查邮箱~');
        return;
      }
      if (this.user_password != this.user_password2) {
        this.$message.error('两次输入的密码不一致~');
        return;
      }
      Get('UserPasswordSet', {
        "user_email": this.user_email,
        "user_password": this.user_password,
        "email_code": this.email_code
      }).then(res => {
        if (res.data.result_code == '100') {
          this.dialogVisible = false
          this.$message({
            type: 'success',
            message: '修改密码成功，请重新登陆~'
          });
        } else {
          this.$message({
            type: 'error',
            message: res.data.result_message
          });
        }
        console.log(res)
      })
    },
    getEmailCode() {
      if (this.user_email) {
          if(!/^([a-zA-Z\d])((\w|-)+\.?)+@([a-zA-Z\d]+\.)+[a-zA-Z]{2,6}$/.test(this.user_email)){
            this.$message.error('邮箱格式有误，请检查邮箱~');
            return;
          }
        }else {
          this.$message.error('请检查邮箱~');
          return;
        }
        Get('SMSPost',{
          email_address:this.user_email,//  是 string  邮箱
        }).then(res=>{
          // let _result = JSON.parse(res.data)
          if(res.data.result_code == '100'){
            this.$message({
              type: 'success',
              message: '已发送，请前往邮箱查收~'
            });
          }else {
            this.$message({
              type: 'error',
              message: res.data.result_message
            });
          }
          console.log(res)
        })
    },
    forgetPassword() {
      this.dialogVisible = true
    },
    handleLogin() {
      if (!this.email && !this.password) {
        this.$message.error('请填写邮箱密码~');
        return;
      }
      if (!/^([a-zA-Z\d])((\w|-)+\.?)+@([a-zA-Z\d]+\.)+[a-zA-Z]{2,6}$/.test(this.email)) {
        this.$message.error('邮箱格式有误，请检查邮箱~');
        return;
      }
      if(!this.isdisabled){
        this.isdisabled = true
        Get('login', {
          "user_email": this.email,
          "user_password": this.password,
        }).then(res => {
          if (res.data.result_code == '100') {
            sessionStorage.setItem('_fruitUser', JSON.stringify(res.data.data))
            this.$store.commit('setUser', res.data.data)
            this.$message({
              type: 'success',
              message: '登录成功~'
            });
            if(this.$route.name != 'index'){
              this.$router.push({
                name: 'index'
              })
            }
            // setTimeout(() => {
            //   this.isdisable = false
            // }, 1000)
            // this.isdisabled = false
            // console.log('this.$store', this.$store.state)
          } else {
            this.$message({
              type: 'error',
              message: res.data.result_message
            });
            this.isdisabled = false
          }
          console.log(res)
        })
      }
    },
    logout() {
      sessionStorage.setItem('_fruitUser', '')
      this.$store.commit('setUser', '')
      this.isdisabled = false
      // console.log('this.$route',this.$route)
      if(this.$route.name != 'index'){
        this.$router.push({
          name: 'index'
        })
      }
    },
    handlePph(){
      // debugger
      this.$router.push({
        name:'polyphenol'
      })
    }
  }
}

</script>
<style scoped>
.header {
  height: auto
}
.headerIndex {
  background: url(/fruit/static/css/banner_bg.jpeg) no-repeat fixed top;
}
.headerIndex .control-label {
  color: #fff
}
.headerIndex h2 {
    color: #fff;
  }
 .headerIndex .top-nav .navbar-default .navbar-nav > li > a {
    color:#fff;
  }
.navbar {
  margin-bottom: 0
}
.login-form2 {
  width: auto;
  padding-bottom: 0;
  position: relative;
    top: 10px;
}
.login-form2 .form-control.input-icon {
  padding-left: 6px;
  border-radius: 4px;
}
.login-form2 .form-horizontal .form-group-right {
  width: 170px;

}
.login-form2 .form-group {
  display: inline-block;
  margin-bottom: 0px
}
.login-form2 .form-horizontal .control-label,.login-form2 .form-pass-eit.form-horizontal>.form-group .control-label {
  width: 50px
}
.login-form2 .form-control {
  padding: 6px 4px
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue